"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../theme");
exports.Container = theme_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 72em;\n\tmargin: 0 auto;\n"], ["\n\twidth: 72em;\n\tmargin: 0 auto;\n"])));
exports.Container.displayName = 'Container';
var templateObject_1;
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@skeoh/pic/out/build/components/Container.js
// module id = 544
// module chunks = 0